import styled from 'styled-components/macro';

import { BREAKPOINTS } from 'utils/styles/breakpoints';
import { COLORS } from 'utils/styles/colors';
import { FLEX_CONTAINER } from 'utils/styles/flex';

export const StyledHeader = styled.header`
  background: ${COLORS.multiGray};
  width: 100%;
  box-shadow: 0px 4px 15px rgba(0, 0, 0, 0.25);
  position: fixed;
  left: 0;
  top: 0;
  z-index: 11;
  transition: .3s;
`;

export const HeaderContainer = styled.div`
  ${FLEX_CONTAINER.FlexSpaceBetweenRow}
  padding: 6px 228px 6px 150px;

  @media ${BREAKPOINTS.xl} {
    padding: 6px 100px;
  }

  @media ${BREAKPOINTS.lg} {
    padding: 6px 80px;
  }

  @media ${BREAKPOINTS.md} {
    padding: 6px 40px;
  }

  @media ${BREAKPOINTS.sm} {
    padding: 6px 30px;
  }
`;
